import React from "react";

import ExecutiveDashboard from "./ExecutiveDashboard";
import BudgetDashboard from "./BudgetDashboard";
import ActivityDashboard from "./ActivityDashboard";
import PerformanceDashboard from "./PerformanceDashboard";
import VarianceDashboard from "./VarianceDashboard";
import OperationsDashboard from "./OperationsDashboard";
import ProjectsDashboard from "./ProjectsDashboard";
import StaffingDashboard from "./StaffingDashboard";
import RequisitionDashboard from "./RequisitionDashboard";
import DataQualityDashboard from "./DataQualityDashboard";

export type DashboardRefreshMode = "auto" | "manual";

export interface DashboardRegistryItem {
  key: string;
  label: string;
  title: string;
  component: React.ComponentType<any>;
  refreshMode: DashboardRefreshMode;
  refreshIntervalSec?: number;
  pinned?: boolean;
  category?: "core" | "finance" | "operations" | "governance";
  description?: string;
}

export const dashboardRegistry: DashboardRegistryItem[] = [
  {
    key: "executive",
    label: "Executive",
    title: "Executive Dashboard",
    component: ExecutiveDashboard,
    refreshMode: "auto",
    refreshIntervalSec: 300,
    pinned: true,
    category: "core",
    description: "Vue de synthèse pour direction générale et management.",
  },
  {
    key: "budget",
    label: "Budget",
    title: "Budget Dashboard",
    component: BudgetDashboard,
    refreshMode: "manual",
    pinned: true,
    category: "finance",
    description: "Pilotage des enveloppes, exécution, engagements et pressions.",
  },
  {
    key: "activity",
    label: "Activity",
    title: "Activity Dashboard",
    component: ActivityDashboard,
    refreshMode: "manual",
    pinned: true,
    category: "operations",
    description: "Suivi de l’avancement des activités et de leur cohérence budgétaire.",
  },
  {
    key: "performance",
    label: "Performance",
    title: "Performance Dashboard",
    component: PerformanceDashboard,
    refreshMode: "manual",
    pinned: true,
    category: "core",
    description: "Pilotage des KPI, axes et performance stratégique.",
  },
  {
    key: "variance",
    label: "Variance",
    title: "Variance Dashboard",
    component: VarianceDashboard,
    refreshMode: "manual",
    pinned: true,
    category: "finance",
    description: "Écarts budgétaires, risques et causes probables.",
  },
  {
    key: "operations",
    label: "Operations",
    title: "Operations Dashboard",
    component: OperationsDashboard,
    refreshMode: "auto",
    refreshIntervalSec: 300,
    pinned: true,
    category: "operations",
    description: "Lecture des dépôts, produits, sites et logistique.",
  },
  {
    key: "projects",
    label: "Projects",
    title: "Projects Dashboard",
    component: ProjectsDashboard,
    refreshMode: "manual",
    pinned: true,
    category: "operations",
    description: "Portefeuille projets, CAPEX, coûts et délais.",
  },
  {
    key: "staffing",
    label: "Staffing",
    title: "Staffing Dashboard",
    component: StaffingDashboard,
    refreshMode: "manual",
    pinned: true,
    category: "operations",
    description: "Effectifs, vacance de postes, recrutement et coûts RH.",
  },
  {
    key: "requisition",
    label: "Requisition",
    title: "Requisition Dashboard",
    component: RequisitionDashboard,
    refreshMode: "auto",
    refreshIntervalSec: 300,
    pinned: true,
    category: "finance",
    description: "Réquisitions, validations, engagements et pipeline de demande.",
  },
  {
    key: "quality",
    label: "Quality",
    title: "Data Quality Dashboard",
    component: DataQualityDashboard,
    refreshMode: "auto",
    refreshIntervalSec: 600,
    category: "governance",
    description: "Complétude, mappings, imports et exceptions de contrôle.",
  },
];

export const defaultDashboardKey = "executive";

export function getDashboardByKey(key?: string) {
  return dashboardRegistry.find((item) => item.key === key) || dashboardRegistry[0];
}
